(function () {
  if (customElements.get('ce-product-price') !== undefined) {
    return;
  }

  class ProductPrice extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        json: '[data-product-price-json]',
      };

      this.elements = null;
      this.json = null;

      this.handleProductVariantId = this.handleProductVariantId.bind(this);
      this.handleProductSellingPlanId = this.handleProductSellingPlanId.bind(this);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    get sellingPlanId() {
      return this.getAttribute('selling-plan-id');
    }

    set sellingPlanId(value) {
      this.setAttribute('selling-plan-id', value);
    }

    static get observedAttributes() {
      return ['selling-plan-id', 'variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'selling-plan-id':
          if (newValue !== null) {
            this._createHTML();
          }

          break;
        case 'variant-id':
          if (newValue !== null) {
            this._createHTML();
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        json: this.querySelector(this.selectors.json),
      };

      this.json = JSON.parse(this.elements.json.textContent);
      this.elements.json.remove();

      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);
      this.elements.product.addEventListener('ce-product:selling-plan-id', this.handleProductSellingPlanId);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);
      this.elements.product.removeEventListener('ce-product:selling-plan-id', this.handleProductSellingPlanId);
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }

    handleProductSellingPlanId(event) {
      this.sellingPlanId = event.detail;
    }

    interpolateTranslationStringPricePerDeliveryDetails(translationString, pricePerDelivery) {
      return translationString.replace('{{ per_delivery_price }}', formatMoney(pricePerDelivery));
    }

    _createHTML() {
      const { price, compareAtPrice, unitPriceDetails, sellingPlanAllocations } = this.json[this.variantId];

      const sellingPlanAllocation = sellingPlanAllocations[this.sellingPlanId];

      const html = `
        ${this.sellingPlanId !== '-1' ? `
          <div class="mb-1 ${this.getAttribute('alignment') === 'left' ? 'text-left' : 'text-center'}">
            <p class="bg-background-alt font-bold-body inline-block px-2 py-1 rounded-other text-xs uppercase">
              ${Themu.t.products.price.subscription}
            </p>
          </div>
        ` : ``}
        <div class="flex items-baseline ${this.getAttribute('alignment') === 'left' ? 'justify-start' : 'justify-center'} -mx-2">
          ${sellingPlanAllocation?.compareAtPrice > sellingPlanAllocation?.price ? `
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.subscription_price}</h4>
              <p class="text-2xl">${formatMoney(sellingPlanAllocation.price)}</p>
            </div>
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.regular_price}</h4>
              <p class="text-lg">
                <s class="no-underline relative before:absolute before:-left-0.5 before:-right-0.5 before:top-1/2 before:bg-danger/90 before:h-1 before:-translate-y-1/2 before:-rotate-6">
                  ${formatMoney(sellingPlanAllocation.compareAtPrice)}
                </s>
              </p>
            </div>
          ` : compareAtPrice > price ? `
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.sale_price}</h4>
              <p class="text-2xl">${formatMoney(price)}</p>
            </div>
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.regular_price}</h4>
              <p class="text-lg">
                <s class="no-underline relative before:absolute before:-left-0.5 before:-right-0.5 before:top-1/2 before:bg-danger/90 before:h-1 before:-translate-y-1/2 before:-rotate-6">
                  ${formatMoney(compareAtPrice)}
                </s>
              </p>
            </div>
          ` : `
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.regular_price}</h4>
              <p class="text-2xl">${formatMoney(price)}</p>
            </div>
          `}
        </div>
        ${sellingPlanAllocation?.perDeliveryPrice != sellingPlanAllocation?.price ? `
          <div class="flex items-baseline ${this.getAttribute('alignment') === 'left' ? 'justify-start' : 'justify-center'} -mx-2 mt-1">
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.price_per_delivery}</h4>
              <p class="text-sm">${this.interpolateTranslationStringPricePerDeliveryDetails(Themu.t.products.price.price_per_delivery_details, sellingPlanAllocation.perDeliveryPrice)}</p>
            </div>
          </div>
        ` : ``}
        ${unitPriceDetails ? `
          <div class="flex items-baseline ${this.getAttribute('alignment') === 'left' ? 'justify-start' : 'justify-center'} -mx-2 mt-1">
            <div class="px-2">
              <h4 class="sr-only">${Themu.t.products.price.unit_price}</h4>
              <p class="text-sm">${unitPriceDetails}</p>
            </div>
          </div>
        ` : ``}
      `;

      this.innerHTML = html;
    }
  }

  customElements.define('ce-product-price', ProductPrice);
})();
